import { render, staticRenderFns } from "./index.vue?vue&type=template&id=246a8424"
import script from "./detailsAssetMasterItems.js?vue&type=script&lang=js&external"
export * from "./detailsAssetMasterItems.js?vue&type=script&lang=js&external"
import style0 from "./detailsAssetMasterItems.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports